import { ApplicationRef, enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppConfigModel } from '@utils/interfaces/app-config.model';
import { AppComponent } from './app/app.component';
import { setupAppConfig } from './app/app.config';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetch('assets/app.config.json')
  .then<AppConfigModel>(response => response.json())
  .then<ApplicationRef>(config => bootstrapApplication(AppComponent, setupAppConfig(config)))

  .catch(err => console.error(err));
